module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9866ab77b90e2820a7c9ad2ad42b63fd.png";